import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import { newProduct } from "../data/data";

import { FiHeart, FiEye, FiBookmark } from "../assets/icons/vander";
import { useGetLatestProductsQuery } from "../redux/services/products";
import { formatNumber } from "../utils/helper";
import { useAddItemtoCartMutation } from "../redux/services/cart";
import { useSelector } from "react-redux";

export default function ArrivalItem() {
  const user = useSelector((state) => state.auth.user);

  const [addProductToCart, { data }] = useAddItemtoCartMutation();

  const { startDate, endDate } = useMemo(() => {
    const now = new Date();
    const sevenDaysAgo = new Date(now);
    sevenDaysAgo.setDate(now.getDate() - 14);

    return {
      startDate: sevenDaysAgo.toISOString(),
      endDate: now.toISOString(),
    };
  }, []);
  const { data: newArrivalProducts, error } = useGetLatestProductsQuery({
    startDate: startDate,
    endDate: endDate,
  });

  
  const handleAddToCart = (details) => {
    addProductToCart({
      quantity: 1,
      product_id: details.id,
      user_id: user.id,
    });
  };

  return (
    newArrivalProducts?.length > 0 && (
      <div className="container lg:mt-24 mt-16">
        <div className="grid grid-cols-1 mb-6 text-center">
          <h3 className="font-semibold text-3xl leading-normal">
            New Arrival Items
        </h3>
        </div>

      <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-6 pt-6">
        {newArrivalProducts?.slice(0, 4)?.map((item, index) => {
          return (
            <div className="group" key={index}>
              <div className="relative overflow-hidden shadow dark:shadow-gray-800 group-hover:shadow-lg group-hover:dark:shadow-gray-800 rounded-md duration-500">
                <img
                  src={item?.image_urls[0]}
                  className="group-hover:scale-110 duration-500"
                  alt=""
                />

                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddToCart(item);
                  }}
                  className="absolute -bottom-20 group-hover:bottom-3 start-3 end-3 duration-500"
                >
                  <Link
                    to="/shop-cart"
                    className="py-2 px-5 inline-block font-semibold tracking-wide align-middle duration-500 text-base text-center bg-slate-900 text-white w-full rounded-md"
                  >
                    Add to Cart
                  </Link>
                </div>

                <ul className="list-none absolute top-[10px] end-4 opacity-0 group-hover:opacity-100 duration-500 space-y-1">
                  <li>
                    <Link
                      to="#"
                      className="size-10 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"
                    >
                      <FiHeart className="size-4"></FiHeart>
                    </Link>
                  </li>
                  <li
                    onClick={() => {
                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });
                    }}
                    className="mt-1 ms-0"
                  >
                    <Link
                      to={`/product-detail-three/${item.id}`}
                      className="size-10 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"
                    >
                      <FiEye className="size-4"></FiEye>
                    </Link>
                  </li>
                  {/* <li className="mt-1 ms-0"><Link to="#" className="size-10 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-center rounded-full bg-white text-slate-900 hover:bg-slate-900 hover:text-white shadow"><FiBookmark className="size-4"></FiBookmark></Link></li> */}
                </ul>

                {/* <ul className="list-none absolute top-[10px] start-4">
                  {item.offer === true && (
                    <li>
                      <Link
                        to="#"
                        className="bg-orange-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5"
                      >
                        {item.tag}
                      </Link>
                    </li>
                  )}
                  {item.tag === "New" && (
                    <li>
                      <Link
                        to="#"
                        className="bg-red-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5"
                      >
                        {item.tag}
                      </Link>
                    </li>
                  )}
                  {item.tag === "Featured" && (
                    <li>
                      <Link
                        to="#"
                        className="bg-emerald-600 text-white text-[10px] font-bold px-2.5 py-0.5 rounded h-5"
                      >
                        {item.tag}
                      </Link>
                    </li>
                  )}
                </ul> */}
              </div>

              <div className="mt-4">
                <Link
                  to={`/product-detail-three/${item.id}`}
                  className="hover:text-orange-500 text-lg font-medium"
                >
                  {item.title}
                </Link>
                <div className="flex justify-between items-center mt-1">
                  <p>
                    {item.sale_price && `$${formatNumber(item.sale_price)}`}
                    <span
                      className={`${
                        item.sale_price && "line-through text-slate-400 ms-1"
                      } `}
                    >
                      {item.price ? `$${formatNumber(item.price)}` : null}
                    </span>
                  </p>
                  {/* <ul className="font-medium text-amber-400 list-none">
                                        <li className="inline"><i className="mdi mdi-star"></i></li>
                                        <li className="inline"><i className="mdi mdi-star"></i></li>
                                        <li className="inline"><i className="mdi mdi-star"></i></li>
                                        <li className="inline"><i className="mdi mdi-star"></i></li>
                                        <li className="inline"><i className="mdi mdi-star"></i></li>
                                    </ul> */}
                </div>
              </div>
            </div>
          );
        })}
        </div>
      </div>
    )
  );
}
